import React from 'react';
import './App.scss';
import MainNavBar from "./MainNavBar";
import Container from "react-bootstrap/Container";
import Footer from "./Footer";
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import VisionMission from './pages/VisionMission';
import About from './pages/About';
import Platform from './pages/Platform';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Pricing from './pages/Pricing';
import WaitlistModal from './components/WaitlistModal';

function App() {
    const [showWaitlist, setShowWaitlist] = React.useState(false);
    const [waitlistReason, setWaitlistReason] = React.useState<'request-access' | 'design-partner' | undefined>(undefined);
    const location = useLocation();

    React.useEffect(() => {
        if (location.hash) {
            const el = document.querySelector(location.hash);
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            window.scrollTo({ top: 0 });
        }
    }, [location]);

    const openWaitlist = (reason?: 'request-access' | 'design-partner') => { setWaitlistReason(reason); setShowWaitlist(true); };

    return (
        <div>
            <header>
                <MainNavBar onOpenWaitlist={openWaitlist}/>
            </header>
            <main>
                <Routes>
                    <Route path="/" element={<Home onOpenWaitlist={openWaitlist} />} />
                    <Route path="/platform" element={<Platform />} />
                    <Route path="/vision" element={<VisionMission />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/pricing" element={<Pricing onOpenWaitlist={openWaitlist} />} />
                </Routes>
            </main>
            <footer className="mt-5 py-5 text-light footer-strip">
                <Container>
                    <Footer/>
                </Container>
            </footer>
            {/* Waitlist Modal */}
            <WaitlistModal show={showWaitlist} onHide={() => setShowWaitlist(false)} presetReason={waitlistReason} />
        </div>
    );
}

export default App;
